import styled from "styled-components";
import { Menu } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const ContextMenuForControl = styled(Menu)`
    && {
        .MuiMenu-list {
            background: ${UIStyleConstants.GRAY_COLOR};
            border-radius: 6px;
            color: ${UIStyleConstants.WHITE_COLOR};
            font-size: 14px;

            img {
                margin-right: 8px;
            }

            .MuiListItem-root {
                border-top: solid 1px ${UIStyleConstants.WHITE_COLOR};

                &:first-child {
                    border-top: none;
                }
            }
        }
    }
`;
